<template>
  <div class="panel-campaign">
    <div v-if="isNewCampaign">
      <diagram-new @handle-card-change="handleCreateCampaign" />
    </div>
    <div v-else>
      <diagram-update
        :key="id"
        :id="id"
        :cards-selected="cardsUpdate"
        :edges-selected="edgesUpdate"
        :filterConnectionsProp="filterConnections"
        :title-campaign="titleCampaign"
        :enabled-campaign-select="enabledCampaignSelect"
        @handle-card-change="handleCardChange"
        @delete-campaign="deleteCampaign"
        @update:titleCampaign="titleCampaign = $event"
      />
    </div>
  </div>
</template>

<script>
import { mapGetters } from 'vuex';
import DiagramNew from './DiagramNew.vue';
import DiagramUpdate from './DiagramUpdate.vue';

export default {
  name: 'CampaignView',
  components: { DiagramNew, DiagramUpdate },
  props: {
    isNewCampaign: {
      type: Boolean,
      default: false,
    },
  },
  data() {
    return {
      titleCampaign: '',
      campaignUpdate: null,
      cardsUpdate: [],
      edgesUpdate: [],
      filterConnections: [],
      id: null,
      enabledCampaignSelect: false,
    };
  },
  computed: {
    ...mapGetters({
      accountId: 'getCurrentAccountId',
      currentUser: 'getCurrentUser',
      campaignSelected: 'campaignsFlow/getCampaignSelected',
    }),
  },
  watch: {
    campaignSelected: {
      handler(newVal, oldVal) {
        if (newVal?.title) {
          if (newVal?.flow?.cards) {
            newVal.flow.cards.forEach(card => {
              card.status_count = newVal?.status_contacts_flows
                ? newVal.status_contacts_flows.filter(
                    status => status.status_id === card.id
                  ).length
                : 0;
            });
          }
          this.campaignUpdate = newVal;
          this.enabledCampaignSelect = newVal?.enabled;
          this.cardsUpdate = newVal?.flow?.cards;
          this.edgesUpdate = newVal?.flow?.edges;
          this.filterConnections = newVal?.flow?.multiple_connections || [];
          this.titleCampaign = newVal.title;
          this.id = newVal.id;
          this.$emit('enable-card-new-campaign', false);
        }
      },
      immediate: true,
      deep: true,
    },
  },

  methods: {
    handleCardChange(payload) {
      this.$store
        .dispatch('campaignsFlow/update', payload)
        .then(() => {
          this.showAlert(this.$t('CAMPAIGN_FLOW.EDIT.API.SUCCESS_MESSAGE'));
          this.closeCampaignSelect();
        })
        .catch(error => {
          this.showAlert(error?.message);
        });
    },

    deleteCampaign() {
      this.$store
        .dispatch('campaignsFlow/delete', this.id)
        .then(() => {
          this.showAlert(this.$t('CAMPAIGN_FLOW.DELETE.API.SUCCESS_MESSAGE'));
          this.closeCampaignSelect();
          this.$emit('enable-card-new-campaign', true);
        })
        .catch(error => {
          this.showAlert(error?.message);
        });
    },

    closeCampaignSelect() {
      this.$store.dispatch('campaignsFlow/setCampaign', { campaign: null });
    },

    handleCreateCampaign(payload) {
      const campaign = {
        ...payload,
        sender_id: this.currentUser.id,
        account_id: this.accountId,
      };

      this.$store
        .dispatch('campaignsFlow/create', campaign)
        .then(() => {
          this.showAlert(this.$t('CAMPAIGN_FLOW.CREATE.API.SUCCESS_MESSAGE'));
        })
        .catch(error => {
          this.showAlert(error?.message);
        });
    },
    showAlert(message) {
      bus.$emit('newToastMessage', message);
    },
  },
};
</script>

<style>


.panel-campaign {
  width: 100%;
}

.form-wrapper {
  padding: 8px 20px;
}

.enableCampaignOn {
  background: var(--g-400) !important;
}
.enableCampaignOff {
  background: var(--y-500) !important;
}
</style>